<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="paymentsLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Wyciąg bankowy</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>


                 <v-menu
                                      v-model="selectedDayMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="selectedDay"
                                          clearable
                                          label="Data"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" v-model="selectedDay" @input="selectedDayMenu = false"></v-date-picker>
                </v-menu>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchPayments"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 

                <v-spacer></v-spacer>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['payment'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
               <v-dialog v-if="user.permissions['payment'] >= 10" v-model="dialog" :max-width="itemViewing?'1100px':'1600px'" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="paymentAddStatus===1 || paymentEditLoadStatus===1 || paymentEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                      <v-dialog v-model="dialogImport" max-width="700px">
                        <template v-slot:activator="{ on }">
                          <v-btn small v-on="on" class="ml-2" color="primary">Wczytaj plik</v-btn>
                        </template>
                        <import-payment-list :fileContent.sync="importLines" @close="closeImport"></import-payment-list>
                      </v-dialog>
                      <!-- <v-btn @click="executeImport(importCurrentIndex)" small>Import</v-btn> -->
                      <v-spacer></v-spacer>
                      <v-dialog  v-model="dialogAmountEditor" max-width="500px">
                            <amount-detailes-editor  
                              v-if="payedAmount"
                              :payed="payedAmount"
                              :payed-meal="payedMeal"
                              :payed-other="payedOther"
                              :payed-stay="payedStay"
                              @close="closeAmountEditor"
                              @amountChange="amountChange($event)"
                              ></amount-detailes-editor>
                      </v-dialog>
                      <v-row dense class='col-5 pt-0 pb-0'>
                                      <v-col class="pt-0">
                                        <v-text-field 
                                        v-model="editedItem.orig_document_number" 
                                        label="Numer dokumentu"
                                        hide-details 
                                        class="ml-4 mr-4"
                                        :error-messages="orig_document_numberErrors"
                                        @blur="$v.editedItem.orig_document_number.$touch()"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col class="pt-0">
                                        <v-menu
                                                    v-model="documentDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    
                                                  >
                                                    <template v-slot:activator="{ on }">
                                                      <v-text-field
                                                        v-model="editedItem.date"
                                                        clearable
                                                        label="Data"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        hide-details 
                                                        v-on="on"
                                                        class="ml-4 mr-4"
                                                        :error-messages="dateErrors"
                                                        @blur="$v.editedItem.date.$touch()"
                                                      ></v-text-field>
                                                    </template>
                                                    <v-date-picker first-day-of-week="1" v-model="editedItem.date" @input="documentDateMenu = false"></v-date-picker>
                                        </v-menu>

                                      </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                          <v-row>
                            <v-col :class="itemViewing?'col-6':'col-6'">
                              <v-card flat class="elevation-1 pb-2" style="background-color: #f4f4f4;">
                                <v-toolbar flat  dense style="background-color: #f4f4f4;">
                                    <v-toolbar-title>Import</v-toolbar-title>
                                    <v-tooltip right v-if="importLines.length>0 && importCurrentIndex!=-1">
                                        <template v-slot:activator="{ on }">
                                        <v-icon
                                          v-on="on"
                                          color="primary" size="28" class="ml-2" 
                                          :disabled="importCurrentIndex < 1 || importRunning || !hasPrevUnsettled" 
                                          @click="importPrevUnsettled"
                                        >
                                          mdi-skip-backward-outline
                                        </v-icon>
                                        </template>
                                          <span>Poprzedni nierozliczony</span>
                                      </v-tooltip>

                                    <v-tooltip right v-if="importLines.length>0">
                                        <template v-slot:activator="{ on }">
                                        <v-icon
                                          :disabled="importCurrentIndex < 1"
                                          v-on="on"
                                          color="primary" size="28" class="ml-2" 
                                          @click="importPrev"
                                        >
                                          mdi-skip-previous-circle-outline
                                        </v-icon>
                                        </template>
                                          <span>Poprzedni wiersz</span>
                                      </v-tooltip>

                                    <v-tooltip right v-if="importLines.length>0 && importCurrentIndex==-1">
                                        <template v-slot:activator="{ on }">
                                        <v-icon
                                          v-on="on"
                                          color="primary" size="28" class="ml-2" 
                                          @click="importNext"
                                        >
                                          mdi-play-circle-outline
                                        </v-icon>
                                        </template>
                                          <span>Uruchom</span>
                                      </v-tooltip>

                                      <v-tooltip right v-if="importLines.length>0 && importCurrentIndex!=-1">
                                        <template v-slot:activator="{ on }">
                                        <v-icon
                                          v-on="on"
                                          color="primary" size="28" class="ml-2" 
                                          :disabled="importLines.length===0 || importRunning || importLines.length==importCurrentIndex + 1" 
                                          @click="importNext"
                                        >
                                          mdi-skip-next-circle-outline
                                        </v-icon>
                                        </template>
                                          <span>Pomiń wiersz</span>
                                      </v-tooltip>

                                      <v-tooltip right v-if="importLines.length>0 && importCurrentIndex!=-1">
                                        <template v-slot:activator="{ on }">
                                        <v-icon
                                          v-on="on"
                                          color="primary" size="28" class="ml-2" 
                                          :disabled="importLines.length===0 || importRunning || importLines.length==importCurrentIndex + 1" 
                                          @click="importNextUnsettled"
                                        >
                                          mdi-skip-forward-outline
                                        </v-icon>
                                        </template>
                                          <span>Kolejny nierozliczony</span>
                                      </v-tooltip>

                                    <v-spacer></v-spacer>
                                    <v-chip
                                      v-if="importCurrentItemSettled"
                                      color="green darken-2"
                                      label
                                      close
                                      close-icon="mdi-close-outline"
                                      outlined
                                      small
                                      class="mr-2"
                                      @click:close="unsettleCurrentImportItem"
                                    >Rozliczone</v-chip>

                                    <v-toolbar-title v-if="importLines.length>0">{{importCurrentIndex + 1}}/{{importLines.length}}</v-toolbar-title>
                                </v-toolbar>
                                <v-container v-if="importLines.length>0 && (client || desc)" dense class="ml-1">
                                  <p class="mb-1"><strong>Nadawca: </strong>{{client}}</p>
                                  <p class="mb-1"><strong>Tytuł: </strong>{{desc}}</p>
                                </v-container>
                                <v-row class="ml-1">
                                <v-col class="col-7">
                                    <children-live-search clearable :selectedChild="editedItemChildId" @childSelected="editedItemChildId=$event" />
                                </v-col>
                                <v-col class="col-5">
                                      <v-text-field
                                          label="Wpłata"
                                          v-model="amount"
                                          class="mr-4"
                                          @input="amountInput"
                                          :error-messages="amountErrors"
                                           @blur="$v.editedItemAmountDec.$touch()"
                                        ></v-text-field>
                                </v-col>
                                </v-row>
                              </v-card>

                              <v-card flat class="elevation-1">
                                <v-data-table
                                  :headers="headersSettlements"
                                  :items="tableSettlements"
                                  class="elevation-0 mt-5"
                                  item-key="id"
                                  show-select
                                  v-model="selectedSettlements"
                                  dense
                                  hide-default-footer
                                  disable-pagination
                                  :sort-by="['year','month']"
                                  style="background-color: #f4f4f4;"
                                  :loading="settlementsLoadStatus===1"
                                >

                                  <template v-slot:top>
                                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                                      <v-toolbar-title>Pozycje do rozliczenia</v-toolbar-title>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        class="mr-2"
                                        :disabled="selectedSettlements.length < 1"
                                        @click="clearSettelments"
                                        color="primary"
                                        small
                                        >Wyczyść
                                      </v-btn>
                                      <v-btn
                                        :disabled="selectedSettlements.length < 1 || $v.amount.$invalid || $v.editedItemAmountDec.$invalid"
                                        @click="addSettlementToDocument"
                                        depressed
                                        color="success"
                                        small
                                        >Dodaj wybrane<v-icon right dark
                                          >mdi-arrow-right-bold-outline</v-icon
                                        ></v-btn>
                                    </v-toolbar>
                                  </template>
                                   <template v-slot:item.child="{ item }">
                                    {{item.child.name+' '+item.child.surname}}
                                  </template>
                                  <template  v-slot:item.month="{ item }">
                                    {{ monthName(item.month) }}
                                  </template>
                                  <template v-slot:item.amount="{ item }">
                                    {{ $n(item.amount-item.posted_without_document, 'currency', 'pl-PL') }} ({{$n(item.fix+item.hour-item.posted_stay_without_document, 'decimal', 'pl-PL')}}/{{$n(item.fix_meal+item.meal-item.posted_meal_without_document, 'decimal', 'pl-PL')}}/{{$n(item.fix_other+item.other-item.posted_other_without_document, 'decimal', 'pl-PL')}})
                                  </template>
               
                                  <template v-slot:item.payed="{ item }">
                                    <template v-if="!$v.amount.$invalid && !$v.editedItemAmountDec.$invalid">{{ $n(item.payed, 'currency', 'pl-PL') }} ({{$n(item.payed_stay, 'decimal', 'pl-PL')}}/{{$n(item.payed_meal, 'decimal', 'pl-PL')}}/{{$n(item.payed_other, 'decimal', 'pl-PL')}})</template>
                                    <v-icon v-if="!$v.amount.$invalid && !$v.editedItemAmountDec.$invalid" @click="payedIndex = tableSettlements.indexOf(item);payedAmount = item.payed;payedStay = item.payed_stay;payedMeal = item.payed_meal;payedOther = item.payed_other;dialogAmountEditor=true"  color="primary" class="ml-1" icon size="22">mdi-playlist-edit</v-icon>
                                  </template>

                                  <template v-slot:header.data-table-select></template>

                                  <template v-if="selectedSettlements.length>0" slot="body.append">
                                      <tr class="v-data-table__selected font-weight-medium subheading">
                                              <td></td>
                                              <td></td>
                                              <td>Suma</td>
                                              <td>{{ $n(sumField('amount')-sumField('posted_without_document'), 'currency', 'pl-PL')}}</td>
                                              <td>{{ $n(sumField('payed'), 'currency', 'pl-PL')}}</td>
                                      </tr>
                                  </template>

                                </v-data-table>
                              </v-card>
                            </v-col>
                            <v-col :class="itemViewing?'col-6':'col-6'">
                              <v-card flat class="elevation-1">
                                <v-data-table
                                  :headers="headersSelected"
                                  :items="tableSelected"
                                  class="elevation-0"
                                  item-key="id"
                                  dense
                                  :hide-default-footer="tableSelected.length<10"
                                  :sort-by="['year','month']"
                                  style="background-color: #f4f4f4;"
                                >

                                  <template v-slot:top>
                                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                                      <v-toolbar-title v-if="!itemViewing">Pozycje wybrane do dokumentu</v-toolbar-title>
                                      <v-toolbar-title v-else>Pozycje dokumentu</v-toolbar-title>
                                      <span class="error--text v-messages text-end">{{selectedErrors}}</span>
                                    </v-toolbar>
                                  </template>
                                  <template v-slot:item.child="{ item }">
                                    {{item.child.name+' '+item.child.surname}}
                                  </template>
                                  <template  v-slot:item.month="{ item }">
                                    {{ monthName(item.month) }}
                                  </template>
                                 <template v-slot:item.amount="{ item }">
                                    {{ $n(item.amount-item.posted_without_document, 'currency', 'pl-PL') }} ({{$n(item.fix+item.hour-item.posted_stay_without_document, 'decimal', 'pl-PL')}}/{{$n(item.fix_meal+item.meal-item.posted_meal_without_document, 'decimal', 'pl-PL')}}/{{$n(item.fix_other+item.other-item.posted_other_without_document, 'decimal', 'pl-PL')}})
                                  </template>
                                  <template v-slot:item.payed="{ item }">
                                    <template>{{ $n(item.payed, 'currency', 'pl-PL') }} ({{$n(item.payed_stay, 'decimal', 'pl-PL')}}/{{$n(item.payed_meal, 'decimal', 'pl-PL')}}/{{$n(item.payed_other, 'decimal', 'pl-PL')}})</template>
                                  </template>
                                   <template v-slot:item.actions="{ item }">
                                      <v-icon size="20" class="" @click="selectedSettlementRemove(item)"> mdi-close-outline</v-icon>
                                    </template> 
                                   <template v-if="tableSelected.length>0" slot="body.append">
                                      <tr class="v-data-table__selected font-weight-medium subheading">
                                              <td></td>
                                              <td></td>
                                              <td>Suma</td>
                                              <td>{{ $n(sumFieldSelected('amount')-sumFieldSelected('posted_without_document'), 'currency', 'pl-PL')}}</td>
                                              <td>{{ $n(sumFieldSelected('payed'), 'currency', 'pl-PL')}}</td>
                                      </tr>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-col>
                          </v-row>

              
                      </v-container>
                    </v-card-text>

                    

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">{{itemViewing||paymentEditing?'Zamknij':'Anuluj'}}</v-btn> 
                      <v-btn color="primary darken-1" text @click="handleSubmit" v-if="!itemViewing" >{{itemEditing || paymentEditing?'Zapisz':'Zatwierdź'}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template  v-slot:item.amount="{ item }">
                {{ $n(item.amount, 'currency', 'pl-PL') }}
             </template>

   
            <template v-slot:item.status2="{ item }">
              <span>{{item.status}}</span>
    
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip v-if="item.can_delete && user.permissions['payment'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.active && item.can_delete && user.permissions['payment'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-btn @click="viewItem(item)" v-if="!item.can_delete && user.permissions['payment'] >= 5" color="primary" x-small>Podgląd</v-btn>
             
                
            </template> 

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.active" disabled></v-simple-checkbox>
            </template>



          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && paymentsLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadPayments" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadPayments" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import Vue from 'vue'
  import i18n from "../main";
  import confirm from '../components/Confirm'
  import minLength from 'vuelidate/lib/validators/minLength'
  import minValue from 'vuelidate/lib/validators/minValue'
  import maxValue from 'vuelidate/lib/validators/maxValue'
  import required from 'vuelidate/lib/validators/required'
  import ChildrenLiveSearch from '../components/ChildrenLiveSearch'
  import ImportPaymentList from '../components/ImportPaymentList'
  import AmountDetailesEditor from '../components/AmountDetailesEditor'
  import { helpers } from 'vuelidate/lib/validators'
//import { colors } from 'vuetify/lib';
  const decimalPL = helpers.regex('decimalPL', /^[-]?\d*(\,\d+)?$/)

  export default {
    components:{
      confirm,
      ChildrenLiveSearch,
      ImportPaymentList,
      AmountDetailesEditor
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      selectedDayMenu:false,
      documentDateMenu:false,
      dialog: false,
      dialogImport:false,
      dialogAmountEditor:false,
      payedIndex:null,
      payedAmount:null,
      payedStay:null,
      payedMeal:null,
      payedOther:null,
      itemEditing:false,
      itemViewing:false,
      search:'',
      itemWasDefault:false,
      selectedSelected:[],
      amount:'',
      client:'',
      desc:'',
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,display:true},
        { text: 'Data', value: 'date',filterable:false,filterColumn:"date",display:true },
        { text: 'Nr dokumentu', value: 'orig_document_number',filterable:true,filterColumn:"number",display:true },
        { text: 'Kwota', value: 'amount',filterable:true,filterColumn:"amount",display:true },
        { text: 'Status', value: 'status2',filterable:false,display:true },
        { text: 'Zatwierdził', value: 'created_by',filterable:true,display:true,filterColumn:"created_by" },
        { text: 'Aktywne', value: 'status',filterable:false,sortable: false,display:true },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false,display:true },
      ],
       headersSettlements: [
        { text: 'Dziecko', value: 'child', sortable: false },
        { text: 'Miesiąc', value: 'month', sortable: false },
        { text: 'Cennik', value: 'rates', sortable: false },
        { text: 'Do zapłaty (P/Ż/I)', value: 'amount', sortable: false},
        { text: 'Wpłacono (P/Ż/I)', value: 'payed', sortable: false},
        { text: '',value:'data-table-select',sortable: false}
      ],
       headersSelected: [
        { text: 'Dziecko', value: 'child', sortable: false },
        { text: 'Miesiąc', value: 'month', sortable: false },
        { text: 'Cennik', value: 'rates', sortable: false },
        { text: 'Do zapłaty (P/Ż/I)', value: 'amount', sortable: false},
        { text: 'Wpłacono (P/Ż/I)', value: 'payed', sortable: false},
        {text:'',value: 'actions'}
      ],
       headersSelectedKW: [
        { text: 'Miesiąc', value: 'month', sortable: false },
        { text: 'Cennik', value: 'rates', sortable: false },
        { text: 'Kwota', value: 'amount', sortable: false},
        { text: 'Wypłacono', value: 'payed', sortable: false},
      ],
      types:[
        {value:'KP',text:'KP - Kasa Przyjmie'},
        {value:'KW',text:'KW - Kasa Wyda'}
      ],
      importRunning:false,
      //importCurrentIndex:-1,
      //importLines:[]
    }),
    validations() {
      return {
        editedItemAmountDec:{
          //maxValue:maxValue(this.maxValue),
          minValue:minValue(0.01)
        },
        amount:{
            required,
            decimalPL,
          },
        editedItem:{
          selected:{
            required,
            minLength: minLength(1),
          },
          orig_document_number:{
            required
          },
          date:{
            required
          },
        }
      }
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = Vue._.find(this.headers,{'value':sortBy[0]}).filterColumn;
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
  
      tableSettlements(val){
        this.selectedSettlements = val;
      },
      selectedSettlements(val){
        this.amountInput();
      },
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      paymentEditStatus(val){
        if(val===2){
          //this.close();
          //this.componentKey += 1;
        }
      },
      paymentAddStatus(val){
        if(val===2){
          //this.close();
          //this.componentKey += 1;
        }
      },
      paymentDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      paymentEditLoadStatus(val){
        if(val===2){
          if(this.importCurrentItem){
            this.amount = this.importCurrentItem.amount;
            this.desc = this.importCurrentItem.desc;
            this.client = this.importCurrentItem.client;
          }
        }
      },
      settlementsAppendStatus(val){
        if(val===2){
          if(this.editedItem.settlements.length>0){
            
            setTimeout(() => {
              if(this.sumField('amount')-this.sumField('posted_without_document') == this.sumField('payed')){
                this.addSettlementToDocument();
                
              }else{
                this.importRunning = false;
              }
            }, 300)

          }else{
            this.importRunning = false;
          }
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getPaymentOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setPaymentOptions', {options:value} )
        }
      },
      selectedDay:{
        get () {
          return this.$store.getters.getPaymentOptions.selectedDay;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedDay = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getPaymentOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getPaymentEdit;
      },
      importLines:{
        get(){
          return this.$store.getters.getPaymentEdit.source.import_list;
        },
        set(value){
          this.$store.commit('setPaymentSourceImportList',value);
        }
      },
      importCurrentIndex:{
        get(){
          return this.$store.getters.getPaymentEdit.source.import_index;
        },
        set(value){
          this.$store.commit('setPaymentSourceImportIndex',value);
        }
      },
      importCurrentItemSettled(){
        return this.importCurrentIndex>-1 && this.importLines[this.importCurrentIndex].hasOwnProperty('settled') && this.importLines[this.importCurrentIndex].settled;
      },
      importCurrentItem(){
        if(!this.importLines || this.importCurrentIndex<0 || this.importLines.length <= this.importCurrentIndex ) return null;
        return this.importLines[this.importCurrentIndex];
      },
      hasPrevUnsettled(){
        //nie ma więcej
        if(this.importCurrentIndex < 0)return false;
        return _.filter(_.slice(this.importLines,0,this.importCurrentIndex),{'settled':false}).length > 0
      },
       hasNextUnsettled(){
        //nie ma więcej
        if(this.importLines.length===this.importCurrentIndex+1)return;
        return _.filter(_.slice(this.importLines,this.importCurrentIndex + 1),{'settled':false}).length > 0
      },
      editedItemChildId:{
         get () {
          return this.$store.getters.getPaymentEdit.child.id;
        },
        set (value) {
          if(value){
            this.$store.commit('setChildChildId',value);
            this.$store.dispatch( 'appendSettlementsForChild', {
              child_id:value,
              document_id:this.editedItem.id,
              type:'WB'
             });
           }else{
              this.$store.commit('setEmptyChildChildId');
              this.$v.$reset()
           }
          
        }
      },
      editedItemType(){
        return this.editedItem.type;
      },
      
      editedItemAmountDec(){
        return this.amount?parseFloat(this.amount.toString().replace(',','.')):null;
      },
      editedItemAmountCur(){
        return i18n.n(this.editedItem.amount, 'currency', 'pl-PL')
      },
      tableItems(){
        return this.$store.getters.getPayments;
      },
      tableSettlements(){
        //return this.editedItem.settlements;
        return this.$store.getters.getFilteredSettlements;
      },
      selectedSettlements:{
        get: function () {
          return this.editedItem.selectedSettlements;
        },
        // setter
        set: function (value) {
          this.$store.commit('setSelectedSettlements',value);
        }
      },
      tableSelected(){
        return this.editedItem.selected;
      },
      paymentsLoadStatus(){
        return this.$store.getters.getPaymentsLoadStatus;
      },
      paymentEditLoadStatus(){
        return this.$store.getters.getPaymentEditLoadStatus();
      },
      paymentEditStatus(){
        return this.$store.getters.getPaymentEditStatus();
      },
      paymentEditText(){
        return this.$store.getters.getPaymentEditText
      },
      paymentEditing(){
        return this.$store.getters.getPaymentEditing;
      },
      childrenLookup() {
        return this.$store.getters.getChildrenLookup;
      },
       childrenLookupLoadStatus() {
        return this.$store.getters.getChildrenLookupLoadStatus;
      },
      paymentAddStatus(){
        return this.$store.getters.getPaymentAddStatus();
      },
      paymentAddText(){
        return this.$store.getters.getPaymentAddText;
      },
      paymentDeleteStatus(){
        return this.$store.getters.getPaymentDeleteStatus();
      },
      settlementsLoadStatus(){
        return this.$store.getters.getSettlementsLoadStatus;
      },
      settlementsAppendStatus(){
        return this.$store.getters.getSettlementsAppendStatus();
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]
        if(!this.showDeleted && this.user.permissions['payment'] <= 5) return localHeaders.filter(h => h.value!=='status' && h.value!=='actions')
        else if(this.showDeleted && this.user.permissions['payment'] <= 5) return localHeaders.filter(h => h.value!=='actions')
        else if(!this.showDeleted) return localHeaders.filter(h => h.value!=='status')
        else return localHeaders
      },
      formTitle () {
        if(this.itemViewing)return 'Podgląd dokumentu'
        return !this.paymentEditing ? 'Nowy wyciąg bankowy' : 'Edycja wyciągu bankowego'
      },
      dateErrors() {
        const errors = [];
        if (!this.$v.editedItem.date.$dirty) return errors;
        !this.$v.editedItem.date.required && errors.push("Data jest wymagana");
        return errors;
      },
      orig_document_numberErrors() {
        const errors = [];
        if (!this.$v.editedItem.orig_document_number.$dirty) return errors;
        !this.$v.editedItem.orig_document_number.required && errors.push("Numer dokumentu jest wymagany");
        return errors;
      },
      amountErrors () {
        var action = 'Wpłata'
        var action2 = 'do zapłaty'

        const errors = []
        if (!this.$v.amount.$dirty) return errors
        !this.$v.amount.required && errors.push('Kwota jest wymagana')
        !this.$v.amount.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        !this.$v.editedItemAmountDec.maxValue && errors.push(action+' nie może być wyższa niż suma '+action2)
        !this.$v.editedItemAmountDec.minValue && errors.push(action+' nie może być równa 0')
        return errors
      },
      selectedErrors () {
        if(!this.$v.editedItem.selected.$dirty) return '';
        if(!this.$v.editedItem.selected.required || !this.$v.editedItem.selected.minLength) return 'Wymagana co najmniej 1 pozycja';
      },
      maxValue(){
        return this.sumField('amount')-this.sumField('posted_without_document');
      },
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadPayments();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadPayments();
          //this.$store.dispatch( 'appendSettlementsForBank', {bank:'123456'} )
        }, 2000)
      }

    },
    methods: {
      // startImport(){
      //   if(this.importLines.length===this.importCurrentIndex+1)return;
      //   this.importCurrentIndex++;
      //   this.amount = this.importLines[this.importCurrentIndex].amount;
      //   this.client = this.importLines[this.importCurrentIndex].client;
      //   this.desc = this.importLines[this.importCurrentIndex].desc;

      //   if(this.importLines[this.importCurrentIndex].bank){
      //     this.importRunning = true;
      //     this.$store.dispatch( 'appendSettlementsForBank', {bank:this.importLines[index].bank} )
      //   }
      // },
      unsettleCurrentImportItem(){
        this.importLines[this.importCurrentIndex].settled = false
        if(this.importLines[this.importCurrentIndex].bank){
           //this.importRunning = true;
           this.$store.dispatch( 'appendSettlementsForBank', {bank:this.importLines[this.importCurrentIndex].bank} )
         }
      },
      importPrev(){
        this.clearSettelments();
        this.importCurrentIndex--;
        //nie ma więcej
        if(this.importCurrentIndex < 0)return;

         this.amount = this.importLines[this.importCurrentIndex].amount;
         this.client = this.importLines[this.importCurrentIndex].client;
         this.desc = this.importLines[this.importCurrentIndex].desc;

        //  if(this.importLines[this.importCurrentIndex].bank && !this.importCurrentItemSettled){
        //    this.importRunning = true;
        //    this.$store.dispatch( 'appendSettlementsForBank', {bank:this.importLines[this.importCurrentIndex].bank} )
        //  }
      },
      importNext(){
        this.clearSettelments();
        //nie ma więcej
        if(this.importLines.length===this.importCurrentIndex+1)return;

        this.importCurrentIndex++;
        this.amount = this.importLines[this.importCurrentIndex].amount;
        this.client = this.importLines[this.importCurrentIndex].client;
        this.desc = this.importLines[this.importCurrentIndex].desc;

        if(this.importLines[this.importCurrentIndex].bank && !this.importCurrentItemSettled){
          this.importRunning = true;
          this.$store.dispatch( 'appendSettlementsForBank', {bank:this.importLines[this.importCurrentIndex].bank} )
        }
      },
      importPrevUnsettled(){
        this.clearSettelments();
        //nie ma więcej
        if(this.importCurrentIndex < 0)return;

        var arr =  _.filter(_.slice(this.importLines,0,this.importCurrentIndex),{'settled':false})
        if(arr.length>0){
          var i = _.indexOf(this.importLines,_.last(arr))
          this.importCurrentIndex = i;
          this.amount = this.importLines[this.importCurrentIndex].amount;
          this.client = this.importLines[this.importCurrentIndex].client;
          this.desc = this.importLines[this.importCurrentIndex].desc;

          if(this.importLines[this.importCurrentIndex].bank && !this.importCurrentItemSettled){
            this.importRunning = true;
            this.$store.dispatch( 'appendSettlementsForBank', {bank:this.importLines[this.importCurrentIndex].bank} )
          }
        }
      },
      importNextUnsettled(){
        this.clearSettelments();
        //nie ma więcej
        if(this.importLines.length===this.importCurrentIndex+1)return;

        var arr =  _.filter(_.slice(this.importLines,this.importCurrentIndex + 1),{'settled':false})
        if(arr.length>0){
          var i = _.indexOf(this.importLines,_.head(arr))
          this.importCurrentIndex = i;
          this.amount = this.importLines[this.importCurrentIndex].amount;
          this.client = this.importLines[this.importCurrentIndex].client;
          this.desc = this.importLines[this.importCurrentIndex].desc;

          if(this.importLines[this.importCurrentIndex].bank && !this.importCurrentItemSettled){
            this.importRunning = true;
            this.$store.dispatch( 'appendSettlementsForBank', {bank:this.importLines[this.importCurrentIndex].bank} )
          }
        }
      },
      clearSettelments(){
        this.$store.commit('setEmptyChild');
        //this.amount = '';
        //this.client = '';
        //this.desc = '';
        this.$v.$reset()
      },
      loadPayments(){
        this.search='';
        var currentOptions = {...this.$store.getters.getPaymentOptions};
        var date = new Date(); 
        currentOptions.orderBy = 'date';
        currentOptions.orderDirection = 'desc';
        currentOptions.selectedDay = undefined;
        currentOptions.selectedType=['WB'];
        this.$store.dispatch( 'setPaymentOptions', {options:currentOptions} )
      },
      loadMore(){
        this.$store.dispatch( 'loadMorePayments' );
      },
      
      editItem (item) {
        this.itemEditing = true
        this.itemViewing = false
        this.$store.dispatch( 'loadDocumentEdit', {slug:  item.id});  
        //this.$store.dispatch( 'loadSettlementsForChild', {child_id:item.child.id});
        this.dialog = true
      },
      viewItem (item) {
        this.itemEditing = true
        this.itemViewing = true
        this.$store.dispatch( 'loadDocumentEdit', {slug:  item.id});  
        //this.$store.dispatch( 'loadSettlementsForChild', {child_id:item.child.id});
        this.dialog = true
      },
      amountInput(){
        if (!this.$v.amount.$invalid && !this.$v.editedItemAmountDec.$invalid && this.tableSettlements.length>0) {
          this.$store.commit('setRecalculateSettlement',{amount:this.amount,user:this.user});
        }
      },
      selectedSettlementRemove(item){
        this.$store.dispatch('loadRemoveFromSelected',{settlement:item});
      },
      monthName(val){
        return Vue._.find(this.lookups.months, {'value':val}).text;
      },
      addSettlementToDocument(){
        if(this.importLines.length>0){
          this.$store.commit('setAddSelectedSettlementsToDocument',this.importLines[this.importCurrentIndex].bank);
          this.amount = '';
          this.importLines[this.importCurrentIndex].settled = true
          this.importNext();
        }
        else this.$store.commit('setAddSelectedSettlementsToDocument',null);
      },
      deleteItem (item) {
       
          this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunąć dokument?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteDocument', {slug:  item.id});
             }
          })
        
      },
      stornItem (id) {
        this.$refs.confirm.open('Storno', 'Czy na pewno chcesz stornować dokument?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'stornDocument', {slug:  id});
            }
        })
      },
      searchPayments(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchPayments',{filterableHeaders:filterableHeaders,q:this.search.replace(/,/, ".")});
        }
      },
      close () {
        this.dialog = false
        this.componentKey += 1;
        this.selectedSettlements = []
        this.selectedSelected = []
        this.amount = undefined
        //this.importLines = [];
        this.desc = '';
        this.client = '';
        //this.importCurrentIndex = -1;
        this.importRunning = false;
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadPaymentEditDefault'); 
          this.$store.dispatch( 'loadPaymentAddDefault');
          this.itemEditing = false
          this.itemViewing = false
        }, 300)
      },
      closeAmountEditor(){
        this.dialogAmountEditor = false;
        setTimeout(() => {
          this.payedIndex = null;
          this.payedAmount = null;
          this.payedStay = null;
          this.payedMeal = null;
          this.payedOther = null;
        }, 300)
      },
      amountChange(val){
        console.log(val);
        this.tableSettlements[this.payedIndex].payed_stay = val.stay;
        this.tableSettlements[this.payedIndex].payed_meal = val.meal;
        this.tableSettlements[this.payedIndex].payed_other = val.other;
      },
      closeImport(){
        this.dialogImport = false
        this.$v.$reset()
      },
      sumField(key) {
        return this.selectedSettlements.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0);
      },
      sumFieldSelected(key) {
        return this.tableSelected.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0);
      },
     handleSubmit () {
         this.editedItem.amount = this.sumFieldSelected('payed');
         this.$v.editedItem.$touch()
         if (this.$v.editedItem.$invalid) {

         } else {
             if (this.itemEditing) {
                this.$store.dispatch( 'editDocument', {
                  slug: this.editedItem.id,
                  type:  'WB',
                  amount: this.editedItem.amount.toString().replace(/\./g, "").replace(/,/, "."),
                  selected: Vue._.map(this.editedItem.selected,function (s) {return {id:s.id,payed:s.payed,payed_stay:s.payed_stay,payed_meal:s.payed_meal,payed_other:s.payed_other,bank:s.bank}}),
                  date:this.editedItem.date,
                  orig_document_number:this.editedItem.orig_document_number,
                  source:this.editedItem.source,
                });
             } else {//new item
                this.$store.dispatch( 'addDocument', {
                  type:  'WB',
                  amount: this.editedItem.amount.toString().replace(/\./g, "").replace(/,/, "."),
                  selected: Vue._.map(this.editedItem.selected,function (s) {return {id:s.id,payed:s.payed,payed_stay:s.payed_stay,payed_meal:s.payed_meal,payed_other:s.payed_other,bank:s.bank}}),
                  date:this.editedItem.date,
                  orig_document_number:this.editedItem.orig_document_number,
                  source:this.editedItem.source,
                });
             }
          }
       },
    },
  }
</script>


<style scoped>
.search{
      max-width: 200px;
}
.choose_date{
      max-width: 150px;
}
</style>